module.exports = __webpack_public_path__ + "img/services-two-1.29c3556c.png";